export function getCourierText(courier) {
  if (courier == "CORREOSEXPRESS") return "Correos Express";
  if (courier == "SEUR") return "Seur";
  if (courier == "UPS") return "UPS";
  if (courier == "OXPERTA") return "Oxperta";
  if (courier == "PALETW") return "Paletways";
  if (courier == "CTT") return "CTT Express";
  if (courier == "FEDEX") return "FedEx";
  return courier;
}

export function getCourierLogo(courier) {
  switch (courier) {
    case "UPS":
      return `static/img/couriers/ups.svg`;
    case "SEUR":
      return `static/img/couriers/seur.svg`;
    case "CORREOSEXPRESS":
      return `static/img/couriers/correosexpress.svg`;
    case "PALETW":
      return `static/img/couriers/paletw.jpeg`;
    case "CTT":
      return `static/img/couriers/ctt.png`;
    case "OXPERTA":
      return `static/img/logo-mini.png`;
    case "FEDEX":
      return `static/img/couriers/fedex.png`;
  }
  return courier;
}
